import Model from './Model';

export default class HomeNews extends Model {
  baseURL() {
    return '';
  }

  resource() {
    return 'home-news';
  }
}
